import { Component, OnInit } from '@angular/core';
import { CompanyParamsService } from '../../services/company-params.service';

@Component({
  selector: 'app-whastapp-button',
  templateUrl: './whastapp-button.component.html',
  styleUrls: ['./whastapp-button.component.scss']
})
export class WhastappButtonComponent implements OnInit {

  whatsappNumber = '';

  constructor(
    public companyParamsService: CompanyParamsService,
  ) { }

  ngOnInit(): void {
    this.whatsappNumber = this.companyParamsService.company.whatsappNumber != '' ?
      (this.isNullOrUndefined(this.companyParamsService.company.whatsappNumber) ? '' : this.companyParamsService.company.whatsappNumber) : '';
  }

  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }

}
